import React, { useState } from 'react';
import { Table, Empty } from 'antd';
import { useHistory } from 'react-router-dom';

import generatePath from '~settings/routing';
import { pmsStatus } from '../../../constants';

export default function LandlordList({
  landlordList = [],
  t,
  queryLandlordByParams = () => {},
  pmsId,
  loading,
}) {
  const history = useHistory();
  const [filter, setFilter] = useState({
    pageNumber: 1,
    pageSize: 10,
  });

  const generateColumns = [
    {
      title: t('cms:cms.pms_integrations.detail.landlord_list.table.name'),
      dataIndex: 'name',
      key: 'name',
      width: 240,
      render: (_, record) => <span>{record?.node?.landlord?.name ?? '-'}</span>,
    },
    {
      title: t('cms:cms.pms_integrations.detail.landlord_list.table.integration_status'),
      dataIndex: 'status',
      key: 'status',
      width: 240,
      render: (_, record) => (
        <div className={`status-tag ${record?.node?.status}`}>
          {pmsStatus[record?.node?.status] ?? '-'}
        </div>
      ),
    },
    {
      title: t('cms:cms.pms_integrations.detail.landlord_list.table.property_count'),
      dataIndex: 'propertiesCount',
      key: 'propertiesCount',
      width: 240,
      render: (_, record) => record?.node?.landlord?.propertiesCount ?? '-',
    },
    {
      title: t('cms:cms.pms_integrations.detail.landlord_list.table.account_manager'),
      dataIndex: 'accountManager',
      key: 'accountManager',
      width: 272,
      render: (_, record) => record?.node?.landlord?.accountManager ?? '-',
    },
  ];

  const handleOnChange = pagination => {
    const { current, pageSize } = pagination;
    setFilter({
      ...filter,
      pageNumber: current ?? filter.pageNumber,
      pageSize: pageSize ?? filter.pageSize,
    });
    queryLandlordByParams({
      variables: { id: pmsId, pageSize: pageSize, pageNumber: current },
    });
  };

  const handleRowClick = currRecord => {
    history.push(generatePath('landlord', { landlordSlug: currRecord.node?.landlord?.slug }));
  };

  if (landlordList?.totalCount > 0) {
    return (
      <div className="pms-landlord-list">
        <div className="landlord-title">
          {t('cms:cms.pms_integrations.detail.landlord_list.title', {
            totalCount: landlordList?.totalCount,
          })}
        </div>
        <div>
          <Table
            rowKey="id"
            scroll={{ x: true }}
            className="table"
            loading={loading}
            columns={generateColumns}
            dataSource={landlordList?.edges}
            pagination={{
              current: filter.pageNumber,
              pageSize: filter.pageSize,
              showSizeChanger: true,
              total: landlordList?.totalCount ?? 0,
            }}
            onChange={handleOnChange}
            onRow={record => ({
              onClick: () => handleRowClick(record),
            })}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="pms-landlord-list">
      <div className="landlord-title">
        {t('cms:cms.pms_integrations.detail.landlord_list.empty.title')}
      </div>
      <Empty
        className="landlord-list-empty"
        description={t('cms:cms.pms_integrations.detail.landlord_list.empty.desc')}
      />
    </div>
  );
}
